/** @jsxImportSource @emotion/react */

import * as ImageMemberVip from "assets/common/images/member-vip";
import {
  ImageGuideMemberVip,
  ImageUpLvMemberVip,
} from "assets/desktop/images/member-vip";
import { ImageBannerVip } from "assets/desktop/images/member-vip";
import Container from "components/common/Container";
import { PATH } from "constants/path";
import { useLocation } from "react-router-dom";
import { isMobile } from "router";

import { VipDetailsStyle } from "./style.index";
import SwiperVipDetails from "./SwiperVipDetails";

export const ListBenefitVip = [
  {
    name: "Tiền thưởng nâng cấp",
    image: ImageMemberVip.ImageVipLvUp,
  },
  {
    name: "Tiền thưởng sinh nhật",
    image: ImageMemberVip.ImageVipBirth,
  },
  {
    name: "Thưởng tháng",
    image: ImageMemberVip.ImageVipMonth,
  },
];
const VipDetails = () => {
  const { pathname } = useLocation();
  const isEvent = pathname === PATH.User.Event;

  return (
    <>
      {!isMobile && !isEvent && (
        <div css={VipDetailsStyle.banner}>
          <img src={ImageBannerVip} alt="" />
        </div>
      )}
      <Container>
        <div css={VipDetailsStyle.wrapper}>
          <div css={VipDetailsStyle.swiper}>
            <SwiperVipDetails />
          </div>
          <div css={VipDetailsStyle.groupBenefit}>
            {ListBenefitVip.map((item, index) => (
              <div key={index} css={VipDetailsStyle.itemBenefit}>
                <div css={VipDetailsStyle.textBox}>
                  <span>{item.name}</span>
                </div>
                <img src={item.image} alt="" />
              </div>
            ))}
          </div>
          <div css={VipDetailsStyle.mainContent}>
            <img src={ImageGuideMemberVip} alt="" />
            <img src={ImageUpLvMemberVip} alt="" />
          </div>
        </div>
      </Container>
    </>
  );
};

export default VipDetails;
